import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface InstanceItem {
  id: string;
  name: string;
  displayname: string;
  [key: string]: unknown;
}

export interface TimezoneOption {
  value?: string;
  text?: string;
  type?: string;
}

export interface LanguageOption {
  value?: string;
  text?: string;
}

export interface DateNumberFormatOption {
  value?: string;
  text?: string;
  datetimepattern?: string;
  culterinfo?: string;
}

export interface CurrencyOption {
  value?: string;
  text?: string;
}

export interface InstanceDomainOption {
  value: string;
}

export interface InstancesData {
  instances: InstanceItem[];
  selectedInstanceName: string;
  selectedInstanceId?: string;
  tenant?: { businessname?: string; [key: string]: unknown } | string;
  timezoneTypes?: string[];
  timezoneOption?: TimezoneOption[];
  dateandNumberFormatOption?: DateNumberFormatOption[];
  currencyOption?: CurrencyOption[];
  languageOption?: LanguageOption[];
  instanceDomainOption?: InstanceDomainOption[];
  [key: string]: unknown;
}

export interface IInstancesPageDataState {
  instancesData: InstancesData;
  currentVersion: string;
}

const initialState: IInstancesPageDataState = {
  instancesData: {
    instances: [],
    selectedInstanceName: "",
  },
  currentVersion: "",
};

const instancesSlice = createSlice({
  name: "instances",
  initialState,
  reducers: {
    saveInstances: (state, action: PayloadAction<InstancesData>) => {
      state.instancesData = action.payload;
    },
    updateInstanceList: (state, action: PayloadAction<InstanceItem[]>) => {
      state.instancesData.instances = action.payload;
    },
    setCurrentVersion: (state, action: PayloadAction<string>) => {
      state.currentVersion = action.payload;
    },
    clearInstancesData: (state) => {
      state.instancesData = {
        instances: [],
        selectedInstanceName: "",
      };
    },
    clearCurrentVersion: (state) => {
      state.currentVersion = "";
    },
    resetInstancesState: () => initialState,
  },
});

export const { saveInstances, updateInstanceList, setCurrentVersion } = instancesSlice.actions;

export default instancesSlice.reducer;
